import getters from './getters';
import mutations from './mutations';
import actions from './actions';


const state = {
  userInfo: {},
  userNetwork: [],
  unansweredNetworkRequestCount: 0,
};

const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
